<template>
  <div class="row">
    <!-- Left side: Draggable list of rules -->
    <div class="col-md-6">
      <h6 class="mb-3">
        Lista reguł eksportu
      </h6>

      <Draggable
        v-model="rules"
        class="draggable"
        ghost-class="ghost"
        :class="{ moving }"
        @start="moving = true"
        @end="moving = false"
      >
        <div
          v-for="(rule, index) in rules"
          :key="index"
          class="rule-item"
          :class="{ 'selected': selectedRuleIndex === index }"
          @click="selectRule(index)"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="rule-name">
              <i class="fas fa-grip-vertical handle mr-2" />
              {{ rule.fieldName || 'Bez nazwy' }}
            </div>
          </div>
        </div>
      </Draggable>

      <div class="mt-3">
        <button
          class="btn btn-sm btn-primary"
          @click="addNewRule"
        >
          <i class="fas fa-plus" />
          Dodaj regułę
        </button>
      </div>
    </div>

    <!-- Right side: Form for editing selected rule -->
    <div class="col-md-6">
      <div v-if="selectedRuleIndex !== null">
        <h6 class="mb-3">
          Edycja reguły
        </h6>

        <div class="rule-form">
          <BFormInput
            v-model="selectedRule.fieldName"
            placeholder="Nazwa pola"
            class="mb-3"
            @input="updateSelectedRule"
          />

          <BFormTextarea
            v-model="selectedRule.fieldRule"
            placeholder="Reguła"
            class="mb-3 money-font small"
            rows="10"
            @input="updateSelectedRule"
          />
          <button
            class="btn btn-sm btn-outline-danger"
            title="Usuń regułę"
            @click.stop="removeRule(selectedRuleIndex)"
          >
            <i class="fas fa-trash" />
            Usuń
          </button>
        </div>
      </div>

      <div
        v-else
        class="text-muted text-center mt-5"
      >
        <i class="fas fa-arrow-left fa-2x mb-3" />
        <p>Wybierz regułę z listy po lewej stronie, aby ją edytować</p>
      </div>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';

export default {
  props: {
    config: Object,
  },
  data: () => ({
    rules: [],
    selectedRuleIndex: null,
    moving: false,
  }),
  components: {
    Draggable,
  },
  computed: {
    selectedRule() {
      if (this.selectedRuleIndex !== null && this.rules[this.selectedRuleIndex]) {
        return this.rules[this.selectedRuleIndex];
      }
      return null;
    },
  },
  watch: {
    rules: {
      deep: true,
      handler(v) {
        this.$emit('rules', v);
      },
    },
  },
  methods: {
    selectRule(index) {
      this.selectedRuleIndex = index;
    },
    addNewRule() {
      const newRule = { fieldName: '', fieldRule: '' };
      this.rules.push(newRule);
      this.selectedRuleIndex = this.rules.length - 1;
    },
    removeRule(index) {
      this.rules.splice(index, 1);
      if (this.selectedRuleIndex === index) {
        this.selectedRuleIndex = null;
      } else if (this.selectedRuleIndex > index) {
        this.selectedRuleIndex -= 1;
      }
    },
    updateSelectedRule() {
      // The rule is already updated through v-model
      // This method can be used for additional validation if needed
    },
  },
  mounted() {
    this.rules = this.config.exportRules.map((x) => ({ ...x }));
  },
};
</script>

<style lang="scss" scoped>
.draggable {
  min-height: 50px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 10px;
  background-color: #f8f9fa;

  &.moving {
    border-color: #007bff;
    background-color: #e3f2fd;
  }
}

.rule-item {
  padding: 12px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #007bff;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
  }

  &.selected {
    border-color: #007bff;
    background-color: #e3f2fd;
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.rule-name {
  flex: 1;
  font-weight: 500;
}

.handle {
  cursor: grab;
  color: #6c757d;

  &:active {
    cursor: grabbing;
  }
}

.rule-actions {
  display: flex;
  gap: 8px;
}

.rule-form {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.ghost {
  opacity: 0.5;
  background-color: #007bff;
  color: white;
}
</style>
